import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { DirectDebitService } from '../data/direct-debit.service';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { CommandBase, MultiselectCommand } from '../../../core/model/command';
import { Observable } from 'rxjs';
import { directDebitCommand } from '../../command/direct-debit';
import { NativeWindowService } from '../../../core/service/native-window.service';

@Injectable()
export class DirectDebitExportCommandHandler implements ICommandHandler {
  constructor(
    private _dataService: DirectDebitService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof MultiselectCommand) {
      return command.id === directDebitCommand.export;
    }
    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof MultiselectCommand) {
      return this._dataService.export(command.items.map(item => item.id)).pipe(map(file => this._nativeWindow.save(file)));
    }
  }
}
